import { FormGroup, FormLabel, TextField } from "@mui/material";
import { FC, useEffect, useState } from "react";
import CrudDialog from "src/pages/Admin/EezyFamily/components/CrudDialog";

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => Promise<void>;
};

const RejectActionDialog: FC<Props> = ({ open, onClose, onConfirm }): JSX.Element => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setReason("");
      setLoading(false);
    }
  }, [open]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onConfirm(reason.trim());
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <CrudDialog
      open={open}
      title="Rejeitar ação"
      onClose={onClose}
      onSubmit={handleSubmit}
      loading={loading}
      submitLabel="Rejeitar"
      maxWidth="xs"
    >
      <FormGroup>
        <FormLabel>Motivo da rejeição</FormLabel>
        <TextField
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={3}
          placeholder="Será enviado ao psicólogo na notificação (opcional)."
          autoFocus
        />
      </FormGroup>
    </CrudDialog>
  );
};

export default RejectActionDialog;
